// extracted by mini-css-extract-plugin
export default {"SignInForm":"SignInForm_SignInForm__SpBS4","logo":"SignInForm_logo__j51EJ"};